interface PageHeroProps {
  title: string;
  subtitle: string;
  badge?: string;
}

const PageHero = ({ title, subtitle, badge }: PageHeroProps) => {
  return (
    <section className="gradient-hero">
      <div className="container-custom text-center py-16 pb-20 animate-hero-enter">
        {badge && (
          <span className="inline-block px-4 py-1.5 rounded-full bg-blue-50 text-primary text-sm font-medium mb-4">
            {badge}
          </span>
        )}
        <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-foreground mb-4">
          {title}
        </h1>
        <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
          {subtitle}
        </p>
      </div>
    </section>
  );
};

export default PageHero;
